import FilterOptionsContainer from './FilterOptionsContainer'

export default FilterOptionsContainer
